<template>
  <div>
    <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
      <a-divider orientation="left">
        Hotel Facilities
      </a-divider>
      <div class="prompt">
        <!-- Wifi -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Wifi"
        >
          <a-checkbox-group
            :options="['rooms', 'lobby']"
          />
        </a-form-item>
        <!-- Mini Bar -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Mini Bar"
        >
          <a-checkbox-group
            :options="['Have a material', 'There is no material']"
          />
        </a-form-item>
         <!-- 健身房 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Gym"
        >
          <a-form-item
            :style="{ display: 'inline-block' }"
          >
            <a-time-picker />
          </a-form-item>
          <span :style="{ display: 'inline-block', width: '10px', textAlign: 'center' }"> </span>
          <a-form-item :style="{ display: 'inline-block', width: 'calc(66% - 12px)' }">
            <a-input
              v-decorator="[
                'gymLocation',
                {rules: [{ required: false, message: 'Please input your gym location!' }]}
              ]"
              placeholder="Please input your gym location"
            />
          </a-form-item>
        </a-form-item>
        <!-- SPA -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="SPA"
        >
          <a-form-item
            :style="{ display: 'inline-block' }"
          >
            <a-time-picker />
          </a-form-item>
          <span :style="{ display: 'inline-block', width: '10px', textAlign: 'center' }"> </span>
          <a-form-item :style="{ display: 'inline-block', width: 'calc(66% - 12px)' }">
            <a-input
              v-decorator="[
                'spaLocation',
                {rules: [{ required: false, message: 'Please input your spa location!' }]}
              ]"
              placeholder="Please input your spa location"
            />
          </a-form-item>
        </a-form-item>
        <!-- swimming pool -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Swimming Pool"
        >
          <a-form-item
            :style="{ display: 'inline-block' }"
          >
            <a-time-picker />
          </a-form-item>
          <span :style="{ display: 'inline-block', width: '10px', textAlign: 'center' }"> </span>
          <a-form-item :style="{ display: 'inline-block', width: 'calc(66% - 12px)' }">
            <a-input
              v-decorator="[
                'swimmingPoolLocation',
                {rules: [{ required: false, message: 'Please input your swimming pool location!' }]}
              ]"
              placeholder="Please input your swimming pool location"
            />
          </a-form-item>
        </a-form-item>
        <!-- bar -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Bar"
        >
          <a-form-item
            :style="{ display: 'inline-block' }"
          >
            <a-time-picker />
          </a-form-item>
          <span :style="{ display: 'inline-block', width: '10px', textAlign: 'center' }"> </span>
          <a-form-item :style="{ display: 'inline-block', width: 'calc(66% - 12px)' }">
            <a-input
              v-decorator="[
                'barLocation',
                {rules: [{ required: false, message: 'Please input your bar location!' }]}
              ]"
              placeholder="Please input your bar location"
            />
          </a-form-item>
        </a-form-item>
        <!-- Hot springs -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Hot Springs"
        >
          <a-checkbox-group
            :options="['Indoor', 'Outdoors']"
          />
        </a-form-item>
        <!-- Banquet space -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Banquet Space"
        >
          <a-form-item
            :style="{ display: 'inline-block' }"
          >
            <a-time-picker />
          </a-form-item>
          <span :style="{ display: 'inline-block', width: '10px', textAlign: 'center' }"> </span>
          <a-form-item :style="{ display: 'inline-block', width: 'calc(66% - 12px)' }">
            <a-input
              v-decorator="[
                'spaceLocation',
                {rules: [{ required: false, message: 'Please input your banquet space location!' }]}
              ]"
              placeholder="Please input your banquet space location"
            />
          </a-form-item>
        </a-form-item>
        <!-- Other equipment -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Other Equipment"
        >
          <a-checkbox-group
            :options="['Boiled water', 'Slippers', 'Hair dryer', 'Bathrobe']"
          />
        </a-form-item>
        <!-- Room to room -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Room to Room"
        >
          <a-checkbox-group
            :options="['Yes', 'No']"
          />
        </a-form-item>
        <a-divider orientation="left">
          Drinking Water
        </a-divider>
        <!-- Drinking water -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="{
            xs: { span: 24 },
            sm: { span: 18 }
          }"
          label="Drinking Water"
        >
          <a-checkbox-group
            :options="['Have a material', 'There is no material', 'Whether can drink directly']"
          />
        </a-form-item>
        <a-divider orientation="left">
          Meals
        </a-divider>
        <!-- Meals -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="{
            xs: { span: 24 },
            sm: { span: 18 }
          }"
          label="Meals"
        >
          <a-form-item
            :style="{ display: 'inline-block', width: 'calc(20% - 12px)' }"
          >
            <a-select
              v-decorator="[
                'meals',
                {rules: [{ required: false, message: 'Please select your meals!' }]}
              ]"
              :showArrow="true"
            >
              <a-select-option value="">All</a-select-option>
              <a-select-option value="Breakfast">Breakfast</a-select-option>
              <a-select-option value="Lunch">Lunch</a-select-option>
              <a-select-option value="Dinner">Dinner</a-select-option>
            </a-select>
          </a-form-item>
          <span :style="{ display: 'inline-block', width: '10px', textAlign: 'center' }"> </span>
          <a-form-item
            :style="{ display: 'inline-block' }"
          >
            <a-time-picker />
          </a-form-item>
          <span :style="{ display: 'inline-block', width: '10px', textAlign: 'center' }"> </span>
          <a-form-item :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }">
            <a-input
              v-decorator="[
                'restaurantName',
                {rules: [{ required: false, message: 'Please input your restaurant name!' }]}
              ]"
              placeholder="Please input your restaurant name"
            />
          </a-form-item>
          <span :style="{ display: 'inline-block', width: '10px', textAlign: 'center' }"> </span>
          <a-form-item
            :style="{ display: 'inline-block' }"
          >
            <a><a-icon type="plus"/></a>
          </a-form-item>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
// import moment from 'moment'
import MaEditor from '@/components/ma/MaTinyMCE'

export default {
  name: 'HotelPrompt',
  components: {
    MaEditor
  },
  props: {
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this)
    }
  },
  mounted () {
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
    }
  }
}
</script>
<style lang="less" scoped>
.prompt .ant-form-item {
  margin-bottom: 4px;
}
.ant-btn-dashed {
  background: #fff;
}
</style>